import React from 'react';
import { FadeIn } from './FadeIn';
import { Quote } from 'lucide-react';
export function TestimonialFeatured() {
  return <FadeIn delay={0.2} data-id="element-366">
      <section className="py-12 px-4 max-w-4xl mx-auto pt-[0px] pb-[0px]" data-id="element-367">
        <div className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-2xl p-8 md:p-12 text-center relative overflow-hidden pt-[0px] pb-[0px]" data-id="element-368">
          <Quote className="absolute top-4 left-4 md:top-8 md:left-8 text-gray-800 w-16 h-16 md:w-24 md:h-24 -z-10 rotate-180 opacity-50" data-id="element-369" />

          <p className="text-xl md:text-3xl font-medium text-gray-200 leading-relaxed mb-6 italic relative z-10" data-id="element-370">
            "Organicé todo el consultorio en una tarde. Los formularios me
            ahorran 20 minutos por consulta."
          </p>

          <div className="flex items-center justify-center gap-3" data-id="element-371">
            <div className="w-10 h-10 bg-green-900 rounded-full flex items-center justify-center text-green-400 font-bold text-lg" data-id="element-372">
              M
            </div>
            <div className="text-left" data-id="element-373">
              <p className="font-bold text-white" data-id="element-374">Mariela G.</p>
              <p className="text-sm text-gray-400" data-id="element-375">
                Lic. en Nutrición · Córdoba
              </p>
            </div>
          </div>
        </div>
      </section>
    </FadeIn>;
}